import { createPopper } from '@popperjs/core';
import { ICON } from '../Icons/Icons';
import UserProfileModal from "../Modals/Profile/UserProfileModal";
import { FEATURE_NAMES } from "../MVC/rolesHelper";

const LIVE_UPDATE_MS = 3000;

export default class SpaceBrowserUserList {
  constructor({ model }) {
    this.model = model;
    this.spaceId = null;
    this.currentUserId = room_config.socketConfig.userId;
    this.onlineUsers = [];
    this.friendsList = [];
    this.friendsLoaded = false;
    this.popperInstance = null;
    this.referenceElement = null;
    this.listRequestId = 0;
    this.renderedSignature = '';
    this.liveUpdateTimer = null;

    this.userProfileModal = new UserProfileModal({ model, isSpaceBrowser: true });
    console.log('this.userProfileModal', this.userProfileModal)

    this.createPopperElement();
    this.initListeners();
    this.startLiveUpdates();
  }

  createPopperElement() {
    this.popper = $(`
      <div class="space-browser-user-list">
        <div class="space-browser-user-list__header">
          <span class="space-browser-user-list__title">Users in this space</span>
          <button class="space-browser-user-list__close" type="button">
            ${ICON.CLOSE}
          </button>
        </div>
        <div class="space-browser-user-list__content">
          <div class="space-browser-user-list__list"></div>
        </div>
      </div>
    `);

    this.popper.hide();
    $(document.body).append(this.popper);
  }

  initListeners() {
    // Close button
    this.popper.find('.space-browser-user-list__close').on('click', () => {
      this.close();
    });

    // Click outside to close
    $(document).on('click', (e) => {
      if (!this.popper.is(':visible')) return;

      if (!this.popper.is(e.target) &&
          this.popper.has(e.target).length === 0 &&
          this.referenceElement &&
          !$(this.referenceElement).is(e.target) &&
          $(this.referenceElement).has(e.target).length === 0) {
        this.close();
      }
    });
  }

  close() {
    this.popper.hide();
    if (this.popperInstance) {
      this.popperInstance.destroy();
      this.popperInstance = null;
    }
    this.referenceElement = null;
  }

  open(targetElement, spaceId) {
    if (!spaceId) {
      console.error('spaceId is required to open SpaceBrowserUserList');
      return;
    }

    this.spaceId = spaceId;
    this.referenceElement = targetElement;
    this.renderedSignature = '';
    this.fetchOnlineUsers();
  }

  startLiveUpdates() {
    this.stopLiveUpdates();
    this.liveUpdateTimer = setInterval(() => {
      this.refreshCardCounts();
      if (this.popper.is(':visible') && this.spaceId) {
        this.fetchOnlineUsers({ refreshOnly: true });
      }
    }, LIVE_UPDATE_MS);
  }

  stopLiveUpdates() {
    if (this.liveUpdateTimer) {
      clearInterval(this.liveUpdateTimer);
      this.liveUpdateTimer = null;
    }
  }

  visibleWorldIds() {
    const ids = [];
    $('.room-card[data-space-id]').each((_, el) => {
      const id = Number($(el).data('space-id'));
      if (id > 0) {
        ids.push(id);
      }
    });
    return [...new Set(ids)];
  }

  pulseOnlineBadge(badge) {
    badge.removeClass('is-entering');
    if (badge[0]) {
      void badge[0].offsetWidth;
    }
    badge.addClass('is-entering');
    badge.one('animationend', () => badge.removeClass('is-entering'));
  }

  refreshCardCounts() {
    const worldIds = this.visibleWorldIds();
    if (!worldIds.length) {
      return;
    }
    const chunks = [];
    for (let i = 0; i < worldIds.length; i += 100) {
      chunks.push(worldIds.slice(i, i + 100));
    }
    chunks.forEach((chunk) => {
      this.model.worldFetcher.getOnlineUserCounts(chunk, (response) => {
        const counts = response && response.counts;
        if (!counts || typeof counts !== 'object') {
          return;
        }
        Object.keys(counts).forEach((worldId) => {
          const badge = $(`.room-card[data-space-id="${worldId}"]`).find('.room-online-users');
          const countEl = badge.find('p');
          const previous = Number(countEl.text());
          const next = Number(counts[worldId]);
          if (!badge.length || !Number.isFinite(next)) {
            return;
          }
          countEl.text(next);
          if (Number.isFinite(previous) && next > previous) {
            this.pulseOnlineBadge(badge);
          }
        });
      });
    });
  }

  fetchOnlineUsers({ refreshOnly = false } = {}) {
    if (!this.spaceId) {
      console.error('spaceId is not set');
      return Promise.resolve();
    }

    const spaceId = this.spaceId;
    const requestId = ++this.listRequestId;

    const usersPromise = new Promise((resolve) => {
      this.model.worldFetcher.getOnlineUsers(spaceId, (response) => {
        resolve(Array.isArray(response) ? response : []);
      }, (error) => {
        console.error("Error fetching online users:", error);
        resolve(null);
      });
    });

    const shouldLoadFriends = !refreshOnly && !this.model.config.isGuest && !this.friendsLoaded;
    const friendsPromise = shouldLoadFriends
      ? new Promise((resolve) => {
        this.model.worldFetcher.getFriendsList((response) => {
          resolve(response && response.data ? response.data : []);
        }, () => {
          resolve([]);
        });
      })
      : Promise.resolve(this.friendsList);

    return Promise.all([usersPromise, friendsPromise]).then(([onlineUsersData, friendsData]) => {
      if (onlineUsersData === null) {
        return;
      }
      if (requestId !== this.listRequestId || String(this.spaceId) !== String(spaceId)) {
        return;
      }
      if (shouldLoadFriends) {
        this.friendsList = friendsData;
        this.friendsLoaded = true;
      }

      this.onlineUsers = this.mergeOnlineUsersWithFriends(onlineUsersData);
      $(`.room-card[data-space-id="${spaceId}"]`).find(".room-online-users p").text(this.onlineUsers.length);

      this.renderUserList();
      if (!refreshOnly) {
        this.showPopper();
      }
    });
  }

  mergeOnlineUsersWithFriends(onlineUsers) {
    return onlineUsers.map(user => {
      const isFriend = this.isFriend(user.userId);
      return {
        ...user,
        isFriend
      };
    });
  }

  isFriend(userId) {
    if (!this.friendsList || this.friendsList.length === 0) {
      return false;
    }
    // getFriendsList returns array with 'id' field, not 'userId'
    return this.friendsList.some(friend => friend.id === userId);
  }

  renderUserList() {
    const signature = this.onlineUsers.map((user) =>
      `${user.userId}|${user.userName}|${user.userAvatarUrl}|${user.isFriend ? 1 : 0}`
    ).join('\n');
    if (signature === this.renderedSignature) {
      return;
    }
    this.renderedSignature = signature;

    const listContainer = this.popper.find('.space-browser-user-list__list');
    const scrollTop = listContainer.scrollTop();
    listContainer.empty();

    if (this.onlineUsers.length === 0) {
      listContainer.html(`
        <div class="space-browser-user-list__empty">
          No users in this space yet
        </div>
      `);
      return;
    }

    this.onlineUsers.forEach(user => {
      const userItem = $(`
        <div class="space-browser-user-list__item" data-user-id="${user.userId}">
          <div class="space-browser-user-list__avatar-wrapper">
            ${user.isFriend ? `<div class="space-browser-user-list__avatar-star">${ICON.SMALL_STAR}</div>` : ''}
            <img class="space-browser-user-list__avatar" 
                 src="${user.userAvatarUrl || '/textures/defaultAvatar.png'}" 
                 alt="${user.userName}">
          </div>
          <span class="space-browser-user-list__name">${user.userName}</span>
        </div>
      `);

      // Add click handler to show profile
      userItem.on('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        this.close();
        console.log('onclick', user.userId, this.currentUserId)
        if (user.userId === this.currentUserId) {
          this.userProfileModal.rerenderContainer();
        } else {
          this.showUserProfile(user.userId, user);
        }
      });

      listContainer.append(userItem);
    });
    listContainer.scrollTop(scrollTop);
  }

  viewerIsGuest() {
    return !!(this.model.config && this.model.config.isGuest);
  }

  bindProfileAction(selector, enabled, handler) {
    const element = $(selector);
    element.off('click.profileAction');
    element.toggleClass('disabled', !enabled);
    if (!enabled) {
      return;
    }
    element.on('click.profileAction', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (element.hasClass('disabled')) {
        return;
      }
      await handler();
    });
  }

  openPeerSpace(userData, peerAction) {
    if (!userData || !userData.url) {
      return;
    }
    const destination = new URL(userData.url, window.location.origin);
    if (peerAction) {
      destination.searchParams.set('peerAction', peerAction);
      destination.searchParams.set('peerId', String(userData.userId));
    }
    $('#guestAndOtherUserProfileModal').removeClass('is-active');
    window.location.assign(destination.toString());
  }

  bindProfileActions(userId, userData) {
    const viewerIsGuest = this.viewerIsGuest();
    const targetIsGuest = !!userData.isGuest;
    const canReachPeer = !!(userData && userData.url);
    const canMessage = false;
    const canCall = false;
    const canChangeFriends = !viewerIsGuest && !targetIsGuest;

    this.bindProfileAction('#peer_jump_to', canReachPeer, async () => {
      if (!viewerIsGuest && !await this.model.validatePlanFeature(FEATURE_NAMES.INVITE_JUMP_TO_USER)) {
        return;
      }
      this.openPeerSpace(userData);
    });
    this.bindProfileAction('#peer_info_chat', canMessage, async () => {
      if (!await this.model.validatePlanFeature(FEATURE_NAMES.ONE_TO_ONE_CHAT)) {
        return;
      }
      this.openPeerSpace(userData, 'chat');
    });
    this.bindProfileAction('#peer_info_video', canCall, async () => {
      if (!await this.model.validatePlanFeature(FEATURE_NAMES.VIDEO_CALLS)) {
        return;
      }
      this.openPeerSpace(userData, 'call');
    });
    this.bindProfileAction('#peer_add_as_friend', canChangeFriends, async () => {
      if (!await this.model.validatePlanFeature(FEATURE_NAMES.BUDDY_LIST)) {
        return;
      }
      this.model.worldFetcher.addAsFriend(userId, () => {
        this.model.info('success', 'Added to friends list');
        this.friendsList.push({
          id: userId,
          username: userData.userName,
          avatar_image_url: userData.userAvatarUrl
        });
        this.onlineUsers = this.mergeOnlineUsersWithFriends(this.onlineUsers);
        userData.isFriend = true;
        $("#peer_add_as_friend").hide();
        $("#peer_remove_as_friend").show().removeClass('disabled');
        $('#peer_is_friend').show();
      });
    });
    this.bindProfileAction('#peer_remove_as_friend', canChangeFriends, () => {
      this.model.worldFetcher.removeFriend(userId, () => {
        this.model.info('success', 'Removed from friends list');
        this.friendsList = this.friendsList.filter(friend => friend.id !== userId);
        this.onlineUsers = this.mergeOnlineUsersWithFriends(this.onlineUsers);
        userData.isFriend = false;
        $("#peer_add_as_friend").show().removeClass('disabled');
        $("#peer_remove_as_friend").hide();
        $('#peer_is_friend').hide();
      });
    });
  }

  showUserProfile(userId, userData) {
    // Open modal
    $('#guestAndOtherUserProfileModal').addClass('is-active');

    // Set basic info from online users data
    $("#peer_info_avatar").attr('src', userData.userAvatarUrl || '/textures/defaultAvatar.png');
    $("#peer_info_username").text(userData.userName);
    $("#peer_info_location").text(userData.currentSceneName || '');

    const viewerIsGuest = this.viewerIsGuest();
    const targetIsGuest = !!userData.isGuest;

    if (!viewerIsGuest && userData.isFriend && !targetIsGuest) {
      $("#peer_add_as_friend").hide();
      $("#peer_remove_as_friend").show();
      $('#peer_is_friend').show();
    } else {
      $("#peer_add_as_friend").show();
      $("#peer_remove_as_friend").hide();
      $('#peer_is_friend').hide();
    }

    this.bindProfileActions(userId, userData);

    if (targetIsGuest) {
      $("#peer_info_interests").html('');
      $("#peer_info_user_plan").html('');
      return;
    }

    // Fetch full profile info
    this.model.showLoading();

    const error = () => {
      this.model.hideLoading();
      this.model.alert('error', $trans('error-user-data-not-found'), { dataLang: 'error-user-data-not-found' });
    };

    const callback = (response) => {
      this.model.hideLoading();
      const { data: { username, birthday, web, city, interests, avatar_image_url, details, subscription } } = response;

      $("#peer_info_avatar").attr('src', avatar_image_url || '/textures/defaultAvatar.png');
      $("#peer_info_birthdate").html(birthday || '');
      $("#peer_info_interests").html(interests || '');
      $("#peer_info_web").html(web || '');
      $("#peer_info_location").html(city || userData.currentSceneName || '');
      $("#peer_info_username").text(username);
      $("#peer_info_bio").text(details || '');
      $("#peer_info_user_plan").text(subscription?.name || 'Free');
    };

    this.model.worldFetcher.getProfileInfo(userId, callback, error);
  }

  showPopper() {
    if (!this.referenceElement) return;

    this.popper.show();

    // Create or update popper instance
    if (this.popperInstance) {
      this.popperInstance.destroy();
    }

    this.popperInstance = createPopper(this.referenceElement, this.popper[0], {
      placement: 'bottom-end',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 8],
          },
        },
        {
          name: 'preventOverflow',
          options: {
            padding: 8,
          },
        },
      ],
    });
  }
}
